<template>
    <div class="info-view">
        <div class="info-view-line">
            <span class="info-view-title">请选择云机版本：</span>
            <el-select v-model="updateCardType" size="mini" placeholder="请选择" width="100px;" @change="changeEngineType(updateCardType)">
                <el-option
                        v-for="item in bmEngineOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="info-view-line" v-if="updateCardType">
            <span class="info-view-title">引擎版本：</span>
            <span class="info-view-title">{{currentEngineVersion.versionCode}}</span>
        </div>
        <div v-if="updateCardType" class="info-view-line">
            <el-button type="primary" size="mini" @click.stop="checkVersion(1)"
                       :disabled="!hasSelect">预下载升级包
            </el-button>
            <el-button type="primary" size="mini" @click.stop="checkVersion(0)"
                       :disabled="!hasSelect">升级云机
            </el-button>
        </div>
        <div class="info-view-line" v-if="updateCardType">
            <div style="width: 100%;height: 1px; background-color: #E1E6EB; margin-top: 10px;"></div>
        </div>
        <div class="info-view-line" v-if="updateCardType">
            <span class="info-view-title">预下载状态：</span>
            <el-select v-model="prepareStatus" size="mini" placeholder="请选择" @change="getPrepareList">
                <el-option
                        v-for="item in prepareStatusOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
            <span class="info-view-title" style="margin-left: 24px;">设备池：</span>
            <el-select v-model="caseNo" size="mini" placeholder="请选择" @change="getPrepareList">
                <el-option
                        v-for="item in deviceCaseList"
                        :key="item.id"
                        :label="item.caseNo"
                        :value="item.caseNo">
                </el-option>
            </el-select>
            <span class="info-view-title" style="margin-left: 24px;">分组：</span>
            <el-select v-model="groupId" size="mini" placeholder="请选择" @change="getPrepareList">
                <el-option
                        v-for="item in groupList"
                        :key="item.id"
                        :label="item.groupName"
                        :value="item.id">
                </el-option>
            </el-select>
        </div>
        <div class="info-view-line" v-if="updateCardType" style="margin-top: 10px;">
            <el-table ref="multipleTable" :data="cardPrepareList"
                      :header-cell-style="{backgroundColor: '#efefef'}" size="mini" @row-click="checkRow"
                      tooltip-effect="dark" style="width: 99%" @selection-change="handleSelectionChange">
                <el-table-column align="center" header-align="center" type="selection"
                ></el-table-column>
                <el-table-column prop="deviceIp" label="云机IP" min-width="40px"></el-table-column>
                <el-table-column prop="versionCode" label="设备当前版本" min-width="70px"></el-table-column>
                <el-table-column label="预下载状态" min-width="70px">
                    <template slot-scope="scope">
                        <span :style="scope.row | statusClassFilter">{{scope.row.prepareStatus | showPrepareStatus}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="versionCodePrepare" label="预下载版本" min-width="70px">
                    <template slot-scope="scope">
                        <span :style="scope.row | statusClassFilter">{{scope.row.versionCodePrepare}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CardUpdate",
        data() {
            return {
                updateCardType: "",
                currentEngineVersion:"",
                engineList: [],
                caseNo: "",
                groupId: "",
                deviceCaseList: [],
                groupList: [],
                bmEngineList: [],
                multipleSelection: [],
                cardPrepareList: [],
                prepareStatus: '',
                prepareStatusOptions: [
                    {
                      label: '全部',
                      value:''
                    },
                    {
                        label: "无",
                        value: 0
                    },
                    {
                        label: "下载中",
                        value: 1
                    },
                    {
                        label: '下载完成',
                        value: 2
                    }
                ]
            }
        },
        filters: {
            showPrepareStatus(val) {
                switch (val) {
                    case 0:
                        return "无"
                    case 1:
                        return "下载中"
                    case 2:
                        return "下载完成"
                }
            },
            statusClassFilter(row) {
                if (row.prepareStatus === 2) {
                    return {color: "green"};
                }
            }
        },
        computed: {
            bmEngineOptions() {
                let list = []
                this.bmEngineList.forEach(v => {
                    list.push({
                        label: v.content,
                        value: v.code
                    })
                })
                // console.log("dddsdfadf")
                return list
            },
            hasSelect() {
                return this.multipleSelection.length > 0;
            }
        },
        methods: {
            getEngineList() {//当前系统内的引擎版本列表
                this.$post(this.$uri.system.engineList, {}).then(res => {
                    // console.log("engineList is " + JSON.stringify(res))
                    this.engineList = res.data
                })
            },
            changeEngineType(updateCardType) {
                // console.log("updateCardType " + updateCardType)
                this.getPrepareList()
                for (let engine of this.engineList) {
                    // console.log("engine is " + JSON.stringify(engine))
                    if (engine.engineType === updateCardType) {
                        this.currentEngineVersion = engine
                        break
                    }
                }
                // console.log("currentEngineVersion " + JSON.stringify(this.currentEngineVersion))
            },
            checkVersion(prepare) {
                let msg = ""

                if (this.multipleSelection.length === 0) {
                    if (prepare) {
                        msg = "请勾选需要预下载升级包的云机"
                    } else {
                        msg = "请勾选需要升级的云机"
                    }
                    this.$confirm(msg, "提醒", {
                        confirmButtonText: "确认",
                        confirmButtonClass: "confirm-btn-blue",
                        iconClass: "el-icon-c-red",
                        showCancelButton: false
                    }).then(() => {
                    }).catch(() => {
                    })
                } else {
                    let deviceIps = []
                    this.multipleSelection.forEach(v => {
                        deviceIps.push(v.deviceIp)
                    })
                    if (prepare) {
                        msg = "确认要让勾选云机预下载升级包?"
                    } else {
                        msg = "确认要让勾选云机开始升级?"
                    }
                    this.$confirm(msg, "提示", {
                        confirmButtonText: '确定',
                        confirmButtonClass: 'confirm-btn-blue',
                        iconClass: 'el-icon-c-blue',
                        cancelButtonText: '取消'
                    }).then(() => {
                        let param = {
                            engineType: this.updateCardType,
                            isAll: 0,
                            deviceIps: deviceIps,
                            isPrepare: prepare
                        }
                        // console.log("engineUpdateExtraInfo is " + JSON.stringify(that.engineUpdateExtraInfo))
                        this.$post(this.$uri.system.engineVersionCheck, {...param}).then(res => {
                            if (res.success) {
                                this.$message.success("发送成功")
                            } else {
                                this.$message.error(res.message)
                            }
                        })
                    }).catch(() => {
                    }).finally(() => {

                    })
                }
            },
            getGroupList() {
                this.$post(this.$uri.group.list, {}).then(res => {
                    if (res.success) {
                        this.groupList = res.list
                        let newGroup = {}
                        newGroup.groupName = "未分组"
                        newGroup.id = 0
                        this.groupList.push(newGroup)
                        console.log("groupList is " + JSON.stringify(this.groupList))
                    }
                })
            },
            /* 获取设备池列表 */
            getDeviceCaseList() {
                this.$post(this.$uri.device.caseList).then(res => {
                    console.log("deviceCaseList is ", JSON.stringify(res))
                    if (res.success) {
                        this.deviceCaseList = res.list
                    }
                })
            },
            getPrepareList() {
                let param = {
                    engineType: this.updateCardType,
                    prepareStatus: this.prepareStatus,
                    caseNo: this.caseNo,
                    groupId: this.groupId
                }
                this.$post(this.$uri.system.enginePrepare, {...param}).then(res => {
                    console.log("prepareList is " + JSON.stringify(res))
                    if (res.success) {
                        this.cardPrepareList = res.list
                    }
                    else {
                        this.cardPrepareList = []
                    }
                })
            },
            getBmEngineList() {
                this.$post(this.$uri.system.engineCodeList, {}).then(res => {
                    // console.log("res is " + JSON.stringify(res))
                    this.bmEngineList = res.list
                })
            },
            checkRow(r, c, e) {
                this.$refs.multipleTable.toggleRowSelection(r)
            },
            handleSelectionChange(val) {
                this.multipleSelection = val
                // console.log(this.multipleSelection)
            },
        },
        mounted() {
            this.getEngineList()
            this.getBmEngineList()
            this.getGroupList()
            this.getDeviceCaseList()
        }
    };
</script>

<style lang="less" scoped>
    .info-view {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        padding: 10px;
        /*border-bottom: 1px solid #E1E6EB;*/
        .info-view-line {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-top: 10px;
        }
        .info-view-title {
            text-align: left;
            font-size: 14px;
            /*font-weight: 600;*/
            padding: 5px 0;
        }
        .info-view-main {
            padding: 10px 10px 10px 120px;
            font-size: 12px;
            display: flex;
            flex-direction: column;
            align-items: left;
            justify-content: flex-start;
            .info-view-item {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                padding: 2px 0;
                height: 30px;
            }
            .info-view-item-btn {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: flex-start;
                padding: 5px 0;
            }
        }
    }

</style>